import request from "../utils/request"

export default {
    /**
     * 功能：获取前台系统配置。
     * 参数：无。
     */
    getConfig() {
        return request({
            url: `/systemConfig?ac=getConfig`,
            method: 'get'
        })
    },

    /**
     * 功能：获取应用安装配置。
     * 参数：无。
     */
    getAppInstallConfig() {
        return request({
            url: `/appInstall?ac=config`,
            method: 'get'
        })
    },

    /**
     * 功能：上传前台图片文件。
     * 参数：data multipart 表单数据。
     * @param {FormData} data multipart 表单数据
     * @returns {Promise<Object>} 图片上传结果
     */
    uploadFrontImage(data) {
        const token = localStorage.getItem('front_token')
        const headers = {}
        if (token) {
            headers.Authorization = `Bearer ${token}`
        }
        return request({
            url: `/file?ac=upload`,
            method: 'post',
            data,
            headers
        })
    }
}
